<template>
    <div class="view view--add-tile-category">
        <edit-tile-category />
    </div>
</template>

<script>
    import editTileCategory from '../../../components/EditTileCategory.vue';

    export default {
        components: {
            editTileCategory
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/categories/Add.vue